import { render, staticRenderFns } from "./purchase_order_edit.vue?vue&type=template&id=2950f08e&scoped=true"
import script from "./purchase_order_edit.vue?vue&type=script&lang=js"
export * from "./purchase_order_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2950f08e",
  null
  
)

export default component.exports